//
//
//
//
//
//

import { getAccount } from '@/utils/format';
export default {
  name: 'ArticleContent',
  data: function data() {
    return {
      url: ""
    };
  },
  mounted: function mounted() {
    var uniquedId = JSON.parse(localStorage.getItem('enterprise')).uniqued;
    var accountNum = getAccount(JSON.parse(localStorage.getItem('userInfo')).phone, uniquedId);
    this.url = "https://doc.tuoluojiang.com/forum?account=".concat(accountNum, "&uniqued=").concat(uniquedId);
  }
};